import { Injectable } from '@angular/core';
import { AppName, AppPlatform, Audience, HostContext, HostLocaleContext, HostPerformanceData, HostScenarioLifecycle, HostUserContext } from '@fluidx/office-fluid-types';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { UserContextService } from '../../shared/shared-context/user-context.service';

@Injectable({
    providedIn: 'root'
})
export class FluidHostContext implements HostContext {
    constructor(
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contextService: ContextService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly userContextService: UserContextService
    ) {}

    public get HostContext() {
        return this;
    }

    // provide a unique correlation id for host context
    private bootId: number = 0;

    public get audience(): Audience {
        const fluidAudience = this.capabilitiesService.capabilities.fluidAudience as Audience;

        // GCC-Moderate support is derived by checking if the Office.com service is in Production
        // but the user is a GCC user.
        if (fluidAudience === 'Production' && this.userContextService.user.isGcc) {
            return 'GCC';
        }

        return fluidAudience;
    }

    public get hostAppVersion(): string {
        return `${this.clientStartupConfigService.config.sharedClientStartupContext.buildId}`;
    }

    public get hostCorrelationId(): string {
        return `${this.clientStartupConfigService.config.sharedClientStartupContext.correlationId}.${this.bootId}`;
    }

    public getBootId(): number {
        return this.bootId;
    }

    public get hostSessionId(): string {
        return this.clientStartupConfigService.config.sharedClientStartupContext.correlationId;
    }

    public hostScenarioLifecycle?: HostScenarioLifecycle;
    public hostScenarioEntryPoint?: string;
    public hostScenarioName?: string;

    public hostScenarioStartTime?: number;

    public hostPerformanceData?: HostPerformanceData;

    public get hostLocaleContext(): HostLocaleContext {
        return {
            uiLanguage: this.contextService.sharedContext.officeMarket.toLowerCase()
        };
    }

    public get hostName(): string {
        return 'Office.com';
    }

    public get hostAppName(): AppName {
        return 'Office.com';
    }

    public get hostAppPlatform(): AppPlatform {
        return 'Web';
    }

    public get userContext(): HostUserContext {
        return { user: {
            id: this.clientStartupConfigService.config.puid,
            tenantId: this.clientStartupConfigService.config.tenantId
        }};
    }

    public resetFluidHostContext(shouldResetContext: boolean) {
        if (shouldResetContext) {
            this.hostScenarioStartTime = undefined;
            this.hostScenarioName = undefined;
        }
        // now that the scenario has been reset, increment the boot ID for the next boot.
        this.bootId++;
    }
}
